module.exports = __webpack_public_path__ + "static/media/logo_vinhphuc.a3b32aab.png";